import { render } from "./MiseAJourInventairePage.vue?vue&type=template&id=36106eab&ts=true"
import script from "./MiseAJourInventairePage.vue?vue&type=script&lang=ts"
export * from "./MiseAJourInventairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__